import { Logger } from 'aws-amplify';
import { VerifyContact } from 'aws-amplify-react';
import React from 'react';
import Button from '../Button';
import ContainerDefault from '../Container';
import Form from '../Form';
import RadioRow from '../RadioRow';
import Row from '../Row';
import Section from '../Section';

const logger = new Logger('VerifyContact');

const Container = ContainerDefault.extend`
    max-width: 20rem;
`;

export default class CustomVerifyContact extends VerifyContact {
    private verifyView() {
        const user = this.props.authData;
        if (!user) {
            logger.debug('no user for verify');
            return null;
        }
        const { unverified } = user;
        if (!unverified) {
            logger.debug('no unverified on user');
            return null;
        }
        const { email, phone_number } = unverified;
        return (
            <div>
                {email ? (
                    <RadioRow
                        placeholder="Email"
                        key="email"
                        name="contact"
                        value="email"
                        onChange={this.handleInputChange}
                    />
                ) : null}
                {phone_number ? (
                    <RadioRow
                        placeholder="Phone Number"
                        key="phone_number"
                        name="contact"
                        value="phone_number"
                        onChange={this.handleInputChange}
                    />
                ) : null}
                <Button onClick={this.verify}>Verify</Button>
            </div>
        );
    }

    private submitView() {
        return (
            <div>
                <input placeholder="Code" key="code" name="code" autoComplete="off" onChange={this.handleInputChange} />
                <Button onClick={this.submit}>Submit</Button>
            </div>
        );
    }

    public render() {
        const { authState, authData } = this.props;

        if (authState !== 'verifyContact') {
            return null;
        }

        return (
            <Section>
                <Container>
                    <Form>
                        <h3>Verify Contact</h3>
                        <p>Account recovery requires verified contact information</p>
                        {this.state.verifyAttr ? this.submitView() : this.verifyView()}
                    </Form>
                    <Row>
                        <Button normal onClick={() => this.changeState('signedIn', authData)}>
                            Skip
                        </Button>
                    </Row>
                </Container>
            </Section>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/cognito/CustomVerifyContact.tsx